 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"acceso_restringido":"acceso_restringido","account_status_employee":"account_status_employee","account_status_students~new_employees~new_income~new_students~new_suppliers":"account_status_students~new_employees~new_income~new_students~new_suppliers","account_status_students":"account_status_students","new_employees~new_students~new_suppliers":"new_employees~new_students~new_suppliers","new_employees":"new_employees","new_students":"new_students","new_suppliers":"new_suppliers","configuration~expenses~income~new_expenses~new_income~new_products~pos_cancellation_request~pos_new_~e2bbcd21":"configuration~expenses~income~new_expenses~new_income~new_products~pos_cancellation_request~pos_new_~e2bbcd21","new_income":"new_income","configuration":"configuration","expenses":"expenses","income":"income","new_expenses":"new_expenses","new_products":"new_products","pos_cancellation_request":"pos_cancellation_request","pos_new_inventory":"pos_new_inventory","pos_new_orders":"pos_new_orders","employees~students~suppliers":"employees~students~suppliers","employees":"employees","students":"students","suppliers":"suppliers","login":"login","pos":"pos","pos_inventory":"pos_inventory","pos_orders":"pos_orders","pos_sale":"pos_sale","products":"products"}[chunkId]||chunkId) + "." + {"acceso_restringido":"d5969294","account_status_employee":"b4d3ae95","account_status_students~new_employees~new_income~new_students~new_suppliers":"70d138aa","account_status_students":"7e4f9832","new_employees~new_students~new_suppliers":"39d4f534","new_employees":"d52c6f12","new_students":"0a00e7f0","new_suppliers":"de139f66","configuration~expenses~income~new_expenses~new_income~new_products~pos_cancellation_request~pos_new_~e2bbcd21":"d18ce12a","new_income":"dc9d1ce8","configuration":"4ba305a9","expenses":"785d2180","income":"4c1372a0","new_expenses":"6ee73035","new_products":"c017825a","pos_cancellation_request":"aac76aca","pos_new_inventory":"e4705be4","pos_new_orders":"0b1478a8","employees~students~suppliers":"605d5cbe","employees":"67b1baba","students":"7c71b984","suppliers":"12894611","login":"e893f401","pos":"a527ff68","pos_inventory":"2ec3e864","pos_orders":"f7f90eef","pos_sale":"f6fb9aad","products":"2ae36aa8","chunk-154174ba":"f4851801","chunk-2d21375a":"d280b1ac","chunk-1b5059cc":"8d3007e9","chunk-27691c9f":"70779981","chunk-2d0abdea":"481f4435","chunk-2d0b21f2":"6cb5499a","chunk-2d0be09c":"24edf6ff","chunk-2d0bffba":"0d64ed1d","chunk-2d0c45e9":"91017fa6","chunk-2d0cc235":"165bb17d","chunk-2d0d4443":"36a8a9b2","chunk-2d0d6372":"5895d6c6","chunk-2d208e7b":"99d6142f","chunk-2d210107":"ca5a00a4","chunk-2d213e02":"25e7d487","chunk-2d216046":"a0c9a63c","chunk-2d21b88f":"c65e0c73","chunk-2d222064":"0051166e","chunk-2d22274a":"35a4124a","chunk-2d225df9":"c3d40057","chunk-2d229ba6":"a8c283e8","chunk-2d22c4e7":"3867410d","chunk-2d230a37":"b940f1df","chunk-598c7aa0":"2b6270d3","chunk-6001a2e4":"31b3b5a6","chunk-60bf5526":"1d839328","chunk-7c375412":"5f159de3"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"account_status_students~new_employees~new_income~new_students~new_suppliers":1,"account_status_students":1,"new_employees~new_students~new_suppliers":1,"new_employees":1,"new_students":1,"new_income":1,"expenses":1,"income":1,"new_expenses":1,"new_products":1,"pos_cancellation_request":1,"pos_new_inventory":1,"pos_new_orders":1,"employees~students~suppliers":1,"login":1,"pos":1,"pos_inventory":1,"pos_orders":1,"pos_sale":1,"products":1,"chunk-154174ba":1,"chunk-1b5059cc":1,"chunk-27691c9f":1,"chunk-60bf5526":1,"chunk-7c375412":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"acceso_restringido":"acceso_restringido","account_status_employee":"account_status_employee","account_status_students~new_employees~new_income~new_students~new_suppliers":"account_status_students~new_employees~new_income~new_students~new_suppliers","account_status_students":"account_status_students","new_employees~new_students~new_suppliers":"new_employees~new_students~new_suppliers","new_employees":"new_employees","new_students":"new_students","new_suppliers":"new_suppliers","configuration~expenses~income~new_expenses~new_income~new_products~pos_cancellation_request~pos_new_~e2bbcd21":"configuration~expenses~income~new_expenses~new_income~new_products~pos_cancellation_request~pos_new_~e2bbcd21","new_income":"new_income","configuration":"configuration","expenses":"expenses","income":"income","new_expenses":"new_expenses","new_products":"new_products","pos_cancellation_request":"pos_cancellation_request","pos_new_inventory":"pos_new_inventory","pos_new_orders":"pos_new_orders","employees~students~suppliers":"employees~students~suppliers","employees":"employees","students":"students","suppliers":"suppliers","login":"login","pos":"pos","pos_inventory":"pos_inventory","pos_orders":"pos_orders","pos_sale":"pos_sale","products":"products"}[chunkId]||chunkId) + "." + {"acceso_restringido":"31d6cfe0","account_status_employee":"31d6cfe0","account_status_students~new_employees~new_income~new_students~new_suppliers":"49f0bd0a","account_status_students":"f31c3b91","new_employees~new_students~new_suppliers":"f31c3b91","new_employees":"89024d74","new_students":"993ba40f","new_suppliers":"31d6cfe0","configuration~expenses~income~new_expenses~new_income~new_products~pos_cancellation_request~pos_new_~e2bbcd21":"31d6cfe0","new_income":"727fe059","configuration":"31d6cfe0","expenses":"2e9191c1","income":"2e9191c1","new_expenses":"fb4dd11f","new_products":"f0c4f0c9","pos_cancellation_request":"31fd3281","pos_new_inventory":"57e1c937","pos_new_orders":"4a34f149","employees~students~suppliers":"9e6e8cd2","employees":"31d6cfe0","students":"31d6cfe0","suppliers":"31d6cfe0","login":"e9bcbff4","pos":"893dc6c9","pos_inventory":"9e6e8cd2","pos_orders":"8a0abc6e","pos_sale":"646c231e","products":"9e6e8cd2","chunk-154174ba":"dc974b21","chunk-2d21375a":"31d6cfe0","chunk-1b5059cc":"f31c3b91","chunk-27691c9f":"f31c3b91","chunk-2d0abdea":"31d6cfe0","chunk-2d0b21f2":"31d6cfe0","chunk-2d0be09c":"31d6cfe0","chunk-2d0bffba":"31d6cfe0","chunk-2d0c45e9":"31d6cfe0","chunk-2d0cc235":"31d6cfe0","chunk-2d0d4443":"31d6cfe0","chunk-2d0d6372":"31d6cfe0","chunk-2d208e7b":"31d6cfe0","chunk-2d210107":"31d6cfe0","chunk-2d213e02":"31d6cfe0","chunk-2d216046":"31d6cfe0","chunk-2d21b88f":"31d6cfe0","chunk-2d222064":"31d6cfe0","chunk-2d22274a":"31d6cfe0","chunk-2d225df9":"31d6cfe0","chunk-2d229ba6":"31d6cfe0","chunk-2d22c4e7":"31d6cfe0","chunk-2d230a37":"31d6cfe0","chunk-598c7aa0":"31d6cfe0","chunk-6001a2e4":"31d6cfe0","chunk-60bf5526":"b1539c4c","chunk-7c375412":"b1539c4c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
